export enum ButtonDirective {
  BookLesson,
  Dashboard,
  TutorDashboard,
}
